import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useFieldArray, useForm } from 'react-hook-form';
import { FormRadioGroup } from 'components/molecules/FormRadioGroup';
import { initialOffencesStepFormValues } from 'models/forms/applicationForm';
import ApplicationStore from 'state/ApplicationStore';
import {
  StyledParagraph,
  StyledStepTitle,
} from 'pages/MyApplicationsPage/ApplicationDetailsPage/ApplicationDetailsStep/WizardSteps/styles';
import AddOffenceListItem from './AddOffenceListItem';

const OffencesStep = () => {
  const {
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: initialOffencesStepFormValues,
  });

  const { fields } = useFieldArray({
    control,
    name: 'offencesList',
  });

  useEffect(() => {
    const formData = ApplicationStore.getStepData('offencesData');
    if (Object.keys(formData).length > 0) {
      reset(formData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box sx={{ marginTop: '24px' }}>
      <StyledStepTitle variant="h4">Offences</StyledStepTitle>
      <StyledParagraph variant="body2">
        You must not withhold information about any conviction. This includes motoring offences
        (including speeding offences), bindovers, formal written cautions and convictions in
        and outside Great Britain, and (by virtue of the Rehabilitation of Offenders Act 1974
        (Exceptions) Order 1975) convictions which are spent under the 1974 Act. A conditional
        discharge and an absolute discharge both count as convictions for this purpose. Details
        of parking offences and fixed penalty notices do not need to be declared.
      </StyledParagraph>
      <StyledParagraph variant="body2">
        Section 21 of the Firearms Act 1968 places restrictions on the possession of firearms
        and ammunition by those previously convicted of crime. A person receiving a sentence of
        imprisonment of three months or more is prohibited from possessing a firearm, shotgun,
        antique firearm, air weapon or ammunition for five years from the date of their
        release. In the case of a suspended sentence the prohibition applies from the second
        day after being sentenced. If the sentence is three years or more the prohibition
        applies for life unless lifted by the Crown (or Sheriff) Court.
      </StyledParagraph>

      <form>
        <FormRadioGroup
          name="convictedOffence"
          label="Have you been convicted of any offence (including speeding but not including parking offences or fixed penalty notices) or received a written caution?"
          options={[
            { label: 'YES', value: '1' },
            { label: 'NO', value: '0' },
          ]}
          control={control}
          errors={errors}
        />

        {fields.map((field, index) => (
          <AddOffenceListItem
            key={field.id}
            arrayName="offencesList"
            index={index}
            control={control}
            errors={errors}
          />
        ))}
      </form>
    </Box>
  );
};

export default OffencesStep;
